"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("atomicComponents/atoms/Icons/Icon"));
var Link_1 = __importDefault(require("atomicComponents/atoms/Text/Link"));
var ModalAlert_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalAlert"));
var utils_1 = require("../../utils");
var SuccessAlertContent = function (_a) {
    var onClose = _a.onClose, rechInvoice = _a.rechInvoice;
    var stripeURL = (0, utils_1.makeStripeURL)(rechInvoice);
    var linkDefs = [stripeURL && { label: 'Stripe', url: stripeURL }].filter(end2end_1.notFalsy);
    return ((0, jsx_runtime_1.jsx)(ModalAlert_1.default, { open: true, status: "success", title: "Invoice marked as paid", onClose: onClose, description: ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ textAlign: "left" }, { children: ["The invoice ", (0, jsx_runtime_1.jsx)("strong", { children: (0, end2end_1.getInvoiceCode)(rechInvoice) }), " is marked as paid on Stripe. Quick access:", (0, jsx_runtime_1.jsxs)("ul", __assign({ style: { marginBottom: 0 } }, { children: [(0, jsx_runtime_1.jsxs)("li", { children: ["Open in ", linkDefs.map(function (_a, idx, arr) {
                                    var url = _a.url, label = _a.label;
                                    return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(Link_1.default, __assign({ inLine: true, href: url }, { children: label })), " ", (0, jsx_runtime_1.jsx)(Icon_1.default, { icon: pro_light_svg_icons_1.faArrowUpRightFromSquare, size: "sm" }), idx !== arr.length - 1 ? ' or ' : ''] }, url));
                                })] }), (0, jsx_runtime_1.jsxs)("li", { children: ["Review ", (0, jsx_runtime_1.jsx)(Link_1.default, __assign({ inLine: true, to: "/recharges/charges/all?filter[customerId]=".concat(rechInvoice.rechargedCustomerId) }, { children: "Charges" }))] })] }))] }))) }));
};
exports.default = SuccessAlertContent;
